import type { IconSvgObject } from './types';

const RightTriangleIcon: IconSvgObject = [
  ["path", { d: "M4.70387 14.2926H7.70387C8.80843 14.2926 9.70387 15.188 9.70387 16.2926V19.2926", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.70387 10.2899H3.69741C4.24969 10.2899 4.69741 10.7376 4.69741 11.2899V18.288C4.69741 18.8403 5.14512 19.288 5.69741 19.288H12.7016C13.2538 19.288 13.7016 19.7357 13.7016 20.288V21.2926M4.70627 6.79476L4.7013 3.71115C4.69987 2.81963 5.77755 2.37201 6.40817 3.00219L21.001 17.5851C21.6305 18.2142 21.1864 19.2903 20.2965 19.2924L17.2046 19.2997", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default RightTriangleIcon;
